/**
 * La única parte del estado de transferencias que toca Firestore, separada por el mismo motivo que
 * `auditLogFirestore.ts`: `confirmStatus.ts` no importa el SDK y se puede testear en node.
 *
 * Una sola query para toda la colección, no una por confirmación: el registro pinta hasta 300 eventos
 * y N lecturas puntuales serían N viajes de red para una pantalla que ya se recarga a mano. La
 * colección tiene un documento por confirmación —no por viaje—, así que es pequeña por construcción.
 */
import { collection, getDocs, limit, query } from 'firebase/firestore';

import { estadoDeDocumento, type EstadoConfirmacion } from './confirmStatus';
import { db } from './firebase';

/** Mismo orden de magnitud que MAX_EVENTOS del audit log: un documento por confirmación. */
const MAX_ESTADOS = 300;

/**
 * Devuelve los estados indexados por `previewId`, que es la clave con la que el registro los busca.
 *
 * Sin `orderBy`: la colección se recorre entera y se indexa, así que ordenarla no aporta nada y
 * ahorra tener que declarar un índice compuesto en Firestore.
 */
export async function leerEstadosDeConfirmacion(): Promise<Map<string, EstadoConfirmacion>> {
  const snap = await getDocs(query(collection(db, 'confirm_status'), limit(MAX_ESTADOS)));

  const porPreviewId = new Map<string, EstadoConfirmacion>();
  for (const doc of snap.docs) {
    porPreviewId.set(doc.id, estadoDeDocumento(doc.id, doc.data() as Record<string, unknown>));
  }
  return porPreviewId;
}
